<template>
  <div>
    <b-container class="golf-park pt-5">
      <b-row class="">
        <b-col cols="12" style="position: relative" class="intro-text mt-md-4">
          <div id="carouselExampleInterval1" class="carousel slide" data-bs-ride="carousel">
            <div class="carousel-inner">
              <div class="carousel-item active" data-bs-interval="4000">
                <img src="/img/golf-park-slider-1.jpg" fluid class="d-block w-100" alt="golf park 1" />
              </div>
              <div class="carousel-item" data-bs-interval="4000">
                <img src="/img/golf-park-slider-2.jpg" fluid class="d-block w-100" alt="golf park 2" />
              </div>
              <div class="carousel-item" data-bs-interval="4000">
                <img src="/img/golf-park-slider-3.jpg" fluid class="d-block w-100" alt="golf park 3" />
              </div>
              <div class="carousel-item" data-bs-interval="4000">
                <img src="/img/golf-park-slider-4.jpg" fluid class="d-block w-100" alt="gold park 4" />
              </div>
            </div>
            <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleInterval1" data-bs-slide="prev">
              <span class="carousel-control-prev-icon" aria-hidden="true"></span>
              <span class="visually-hidden">Previous</span>
            </button>
            <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleInterval1" data-bs-slide="next">
              <span class="carousel-control-next-icon" aria-hidden="true"></span>
              <span class="visually-hidden">Next</span>
            </button>
          </div>
        </b-col>
      </b-row>
      <div class="textGolfPark">
        <b-row>
          <b-col cols="12" offset="0" md="10" offset-md="1" lg="8" offset-lg="2">
            <h1>
              FOR THOSE WHO VALUE...<br class="d-none d-sm-block" />
              NATURE &amp; RECREATION
            </h1>
            <p>
              MVP is perfectly positioned to take advantage of South Barrie's ever-growing selection of convenient urban amenities. There are numerous major
              shops and plazas along Mapleview Drive and Big Bay Point Road. Pick up everyday essentials just 5 minutes away at Walmart or Costco. Sample over a
              dozen local restaurants less than 10 minutes away. Hop on Highway 400 and arrive at Tanger Outlets in less than 15 minutes, or head downtown to
              enjoy great dining and shopping destinations along Bayfield Road.
            </p>
            <b-img class="sport" src="/img/sport-1.png" fluid />
            <b-img class="sport" src="/img/sport-2.png" fluid />
            <b-img class="sport" src="/img/sport-3.png" fluid />
          </b-col>
        </b-row>
      </div>
      <!-- <b-col md="2" offset-md="1" offset-lg="2" class="d-none d-sm-none d-md-block arrows">
        <b-row>
          <b-col @click="prev">
            &larr;
          </b-col>
          <b-col @click="next">
            &rarr;
          </b-col>
        </b-row>
      </b-col> -->
    </b-container>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      slide: 0,
      sliding: null,
      // downtownSlick: {
      //   speed: 1500,
      //   autoplay: true,
      //   autoplaySpeed: 2500,
      //   slidesToShow: 1,
      //   arrows: true,
      //   infinite: true,
      //   dots: false,
      //   responsive: [{
      //     breakpoint: 768,
      //     settings: {
      //       dots: true
      //     }
      //   }]
      // }
    };
  },
  mounted() {},
  methods: {
    next() {
      this.$refs.myCarousel.next();
    },
    prev() {
      this.$refs.myCarousel.prev();
    },
  },
};
</script>

<style lang="scss">
.golf-park {
  .image-holder {
    img {
      width: 100%;
    }
  }
  .slick-arrow {
    background-color: red;
  }

  .textGolfPark {
    text-align: center;
    // background-color: #F1F1F2;
    h1 {
      padding-top: 25px;
      font-weight: normal;
      font-size: 40px;
      @media screen and (max-width: 768px) {
        font-size: 25px;
      }
      color: #f05b2d;
    }
    p {
      font-size: 14px;
      @media screen and (max-width: 768px) {
        padding: 15px;
      }
    }
    .sport {
      width: 60px;
      margin: 10px 40px 25px 40px;
      @media screen and (max-width: 768px) {
        margin: 10px 16px 25px 16px;
      }
    }
  }
}
</style>
